import { isEqual, isPast } from 'date-fns';
import { getOrderExpiry } from './get-order-expiry';
/**
 * Returns whether the order has expired.
 */
export const hasOrderExpired = () => {
    const expiry = getOrderExpiry();
    if (!expiry)
        return false;
    return isPast(expiry) || isEqual(expiry, new Date(Date.now()));
};
//# sourceMappingURL=has-order-expired.js.map